import { msgBoxConfirmPopup } from '@utils/confirmBox';
import {
  QUOTES_VIEW,
  SALES_VIEW,
  PURCHASES_VIEW,
  INVOICES_VIEW,
  INTERNAL_PO_VIEW,
  TRANSFERS_VIEW,
  INBOUND_VIEW,
  OUTBOUND_VIEW,
  RETURNS_VIEW,
} from '@utils/permissions'

export const SHIPPABLE_ITEM_TYPES = ['stock', 'product', 'manufactured_item'];

export function requestUserLockingConsent () {
  const messageWrapper = msgBoxConfirmPopup.bind(this)
  return messageWrapper(
    `This action will prevent anymore edits from being made.`, {
      title: 'Confirmation',
      okTitle: `Yes, Lock it down`,
      footerClass: `cascade-1-md:w-40 cascade-1-w-full`
    },
  )
}

export function checkAreAnyItemsAllocatedByStock (itemGroups) {
  if (itemGroups && itemGroups.length) {
    for (const group of itemGroups) {
      for (const item of group.items) {
        if (item.type === "extra_item" || ! item.is_allocated) {
          continue
        }
        if (item.allocated_status === 1) {
          return true
        }
      }
    }
    return false
  }
  return false
}
export function checkAreAllItemsAllocated (itemGroups) {
  if (itemGroups && itemGroups.length) {
    for (const group of itemGroups) {
      for (const item of group.items) {
        if (item.type === "extra_item") {
          continue
        }
        if (! item.is_allocated) {
          return false
        }
      }
    }
    return true
  }
  return false
}

export function checkAreAllItemsUnAllocated (itemGroups) {
  if (itemGroups && itemGroups.length) {
    for (const group of itemGroups) {
      for (const item of group.items) {
        if (item.is_allocated) {
          return false
        }
      }
    }
    return true
  }
  return false
}

export function checkAreAllItemsShipped (itemGroups) {
  if (itemGroups && itemGroups.length) {
    for (const group of itemGroups) {
      for (const item of group.items) {
        if (!SHIPPABLE_ITEM_TYPES.includes(item.type)) {
          continue;
        }
        if (! item.shipping_status) {
          return false
        }
      }
    }
    return true
  }
  return false
}

export function checkOnlyNonShippableItems (itemGroups) {
  if (itemGroups && itemGroups.length) {
    for (const group of itemGroups) {
      for (const item of group.items) {
        if (SHIPPABLE_ITEM_TYPES.includes(item.type)) {
          return false
        }
      }
    }
    return true
  }
  return false
}

export function checkAreAllItemsInvoiced (itemGroups) {
  if (itemGroups && itemGroups.length) {
    for (const group of itemGroups) {
      for (const item of group.items) {
        if (item.type === "extra_item") {
          continue
        }
        if (! item.invoice_status  || item.invoice_status === '' || item.invoice_status === 'returned') {
          return false
        }
      }
    }
    return true
  }
  return false
}

export function checkAreAllItemsReturned (itemGroups) {
  if (itemGroups && itemGroups.length) {
    for (const group of itemGroups) {
      for (const item of group.items) {
        if (item.type === "extra_item") {
          continue
        }
        if (!item.returned_status || item.returned_status === '') {
          return false
        }
      }
    }
    return true
  }
  return false
}

export function resolveRouterObjectForDocument(documentItem, params) {
  if (!documentItem || !documentItem.type || !documentItem.documentId)
    return {};

  switch (documentItem.type) {
    case "P":
      if (!params  || !documentItem.documentId)
        return {};
      return { name: "edit-project", params: { ...params, id: documentItem.documentId, tab: 'dashboard' } }
    case "QU":
      if (!params || !params.id)
        return {};
      return { name: 'projects-tabs-update', params: { ...params, tab: 'quotes', tabId: documentItem.documentId, action: 'update' } }
    case "SO":
      if (!params || !params.id)
        return {};
      return { name: 'projects-tabs-update', params: { ...params, tab: 'sale-orders', tabId: documentItem.documentId, action: 'update' } }
    case "PO":
      if (!params || !params.id)
        return {};
      return { name: 'projects-tabs-update', params: { ...params, tab: 'purchase-orders', tabId: documentItem.documentId, action: 'update' } }
    case "IV":
      if (!params || !params.id)
        return {};
      return { name: 'projects-tabs-update', params: { ...params, tab: 'invoices', tabId: documentItem.documentId, action: 'update' } }
    case "IB":
      return { name: 'stocks-tab-update', params: { tab: 'inbounds', id: documentItem.documentId, action: 'update' } }
    case "OB":
      return { name: 'stocks-tab-update', params: { tab: 'outbounds', id: documentItem.documentId, action: 'update' } }
    case "TF":
      return { name: 'stocks-tab-update', params: { tab: 'transfers', id: documentItem.documentId, action: 'update' } }
    case "IPO":
      return { name: 'stock-purchase-update', params: { id: documentItem.documentId, action: 'update' } }
    case "RES":
      return { name: "returns-update", params: { tab: 'listing', id: documentItem.documentId } }
    case "CN":
      return { name: "returns-update", params: { tab: 'credit-notes', id: documentItem.documentId } }
    default:
      return {};
  }
}

export function resolveDocumentTypeByCode(type) {
  switch(type) {
    case "QU":
      return "quotes"
    case "SO":
      return "sale-orders"
    case "PO":
      return "purchase-orders"
    case "IV":
      return "invoice-orders"
    case "IPO":
      return "internal-purchase-orders"
    case "RES":
      return "return-orders"
    case "TF":
      return "transfers"
    case "IB":
      return "transfer-inbounds"
    case "OB":
      return "transfer-outbounds"
    default:
      return ""
  }
}
export function resolveTypeForDocument(type) {
  switch(type) {
    case "P":
      return "Project"
    case "QU":
      return "Quote"
    case "SO":
      return "Sales Order"
    case "PO":
      return "Purchase Order"
    case "IV":
      return "Invoice"
    case "IPO":
      return "Stock Purchase"
    case "RES":
      return "Return"
    case "CN":
      return "Credit Notes"
    case "TF":
      return "Transfer"
    case "IB":
      return "Inbound"
    case "OB":
      return "Outbound"
    default:
      return ""
  }
}

export function resolveTypeOrderedIndex(type) {
  switch(type) {
    case "P":
    case "Project":
      return 0
    case "QU":
    case "Quote":
      return 10
    case "SO":
    case "Sales Order":
      return 20
    case "IV":
    case "Invoice":
      return 30
    case "PO":
    case "Purchase Order":
      return 40
    case "IPO":
    case "Stock Purchase":
      return 50
    case "RES":
    case "Return":
      return 90
    case "CN":
    case "Credit Notes":
      return 100
    case "IB":
    case "Inbound":
      return 60
    case "OB":
    case "Outbound":
      return 70
    case "TF":
    case "Transfer":
      return 80
    default:
      return 9999
  }
}

export function resolveDocumentKeyForSnakeCase(snakeCaseDocumentType){
  switch(snakeCaseDocumentType){
    case 'quote':
      return 'QU'
    case 'sale_order':
      return 'SO'
    case 'purchase_order':
      return 'PO'
    case 'invoice_order':
      return 'IV'
    case 'internal_purchase_order':
      return 'IPO'
    case 'transfer_inbound':
    case 'transfer_inbound_child':
      return 'IB'
    case 'transfer_outbound':
    case 'transfer_outbound_child':
      return 'OB'
    case 'transfer':
    case 'transfer_child':
      return 'TF'
    case 'return_order':
      return 'RES'
    case 'credit_note':
      return 'CN'
    case 'project':
      return 'P'
    default:
      return ''
  }
}
export function resolveEditPermissionsForDocumentByType(type){
  switch(type) {
    case "Project":
      return QUOTES_VIEW
    case "Quote":
      return QUOTES_VIEW
    case "Sales Order":
      return SALES_VIEW
    case "Purchase Order":
      return PURCHASES_VIEW
    case "Invoice":
      return INVOICES_VIEW
    case "Stock Purchase":
      return INTERNAL_PO_VIEW
    case "Return":
      return RETURNS_VIEW
    case "Credit Note":
      return RETURNS_VIEW
    case "Inbound":
      return INBOUND_VIEW
    case "Outbound":
      return OUTBOUND_VIEW
    case "Transfer":
      return TRANSFERS_VIEW
    default:
      break;
  }
}

export function resolveContactForDocument(document) {
  switch(document.type) {
    case "QU":
      if (document.send_to)
        return document.send_to
      break;
    case "SO":
      if (document.send_to)
        return document.send_to
      break;
    case "PO":
      if (document.send_to)
        return document.send_to
      break;
    case "IV":
      if (document.send_to)
        return document.send_to
      break;
    case "IPO":
      return "Internal Purchase"
    case "RES":
      return "TBD"
    case "CN":
      return "TBD"
    case "TF":
      return "Transfer"
    case "IB":
      return "TBD"
    case "OB":
      if (document.delivery_address && document.delivery_address.business_name)
        return document.delivery_address.business_name
      break;
    default:
      return ""
  }
}

export function resolveDocumentTotal(document) {
  switch(document.type) {
    case "IB":
      return ''
    case "OB":
      return ''
    case "RES":
      return ''
    case "REC":
      return ''
    case "CN":
      return ''
    default:
      return '$' + document.total
  }
}

export function resolveDocumentDenominationTotal(document) {
  const THOUSAND = 1000
  const MILLION = 1000000
  const baseValue = this.resolveDocumentTotal(document)
  const baseTotal = baseValue.replace(',','').replace('$','')
  if (baseTotal && baseTotal > 0){
    const millionth = Math.round(parseInt(baseTotal) / MILLION)
    const thousanth = Math.round(parseInt(baseTotal) / THOUSAND)
    if (millionth > 10){
      // return as $xxxM
      return `$${millionth}M`
    }
    if (thousanth > 10){
      // return as $xxxK
      return `$${thousanth}K`
    }
  }
  // return as $xxx.xx
  return baseValue
}

export const DOCUMENTS_CAN_CHANGE_ADDITIONAL = ['SO', 'IV'];
